'use strict';
module.exports = Backbone.Model.extend({
    errors: {
        'TRC_002': 'emailEmpty',
        'TRC_003': 'noBookingFound',
        'default': 'requestError',
    },
    trackErrors: {
        email: {
            empty: 'email_missing_error',
            invalid: 'email_invalid_error',
        },
        bookingRef: {
            empty: 'reference_missing_error',
            invalid: 'reference_invalid_error',
        },
    },

});
